"use strict";
document.addEventListener( 'DOMContentLoaded', function () {
  new Splide( '#testimonial-carousel', {
		perPage: 1,
        type: 'loop',
        autoplay: true,
        arrows: false,
		breakpoints: {
			640: {
				perPage: 1
			},
		},
  }).mount();
});


document.addEventListener("DOMContentLoaded", () => {
  // OPEN POPUP
  document.querySelectorAll(".open-popup").forEach(button => {
    button.addEventListener("click", () => {
      const popupId = button.dataset.popbtnId;
      const popup = document.querySelector(
        `.popup-wrapper[data-popup-id="${popupId}"]`
      );
      if (popup) {
        popup.classList.remove("popup-hidden");
      }
    });
  });

  // CLOSE POPUP BUTTON
  document.querySelectorAll(".close-popup").forEach(button => {
    button.addEventListener("click", () => {
      const popup = button.closest(".popup-wrapper");
      if (popup) {
        popup.classList.add("popup-hidden");
      }
    });
  });

  // CLOSE ON OVERLAY CLICK
  document.querySelectorAll(".popup-wrapper").forEach(wrapper => {
    wrapper.addEventListener("click", (e) => {
      // Only close if clicking outside popup-content
      if (!e.target.closest(".popup-content")) {
        wrapper.classList.add("popup-hidden");
      }
    });
  });
});

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelector(this.getAttribute('href')).scrollIntoView({
          behavior: 'smooth'
      });
  });
});
